import React from "react";

function IconArrowShortOrange(data) {

    var classes = ''
    if(data.direction && data.direction === 'up') {
        classes = data.classes + ' inline-block rotate-270'
    } else if(data.direction && data.direction === 'down') {
        classes = data.classes + ' inline-block rotate-90'
    } else if(data.direction && data.direction === 'left') {
        classes = data.classes + ' inline-block rotate-180'
    } else {
        classes = data.classes + ' inline-block'
    }

    return (

        <svg width={data.w} height={data.h} viewBox="0 0 66 58" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" className={classes}>
            <defs>
                <filter x="-71.9%" y="-95.8%" width="243.8%" height="291.7%" filterUnits="objectBoundingBox" id="filter-ywffxgcyxm-1">
                    <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                    <feGaussianBlur stdDeviation="5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                    <feColorMatrix values="0 0 0 0 1   0 0 0 0 0.518   0 0 0 0 0  0 0 0 0.25 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
                    <feMerge>
                        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                        <feMergeNode in="SourceGraphic"></feMergeNode>
                    </feMerge>
                </filter>
            </defs>
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="DKT-System/Button/Text-Link-zweizeilig" transform="translate(-4.000000, -17.000000)">
                    <g id="Pfeil" filter="url(#filter-ywffxgcyxm-1)" transform="translate(21.000000, 34.000000)">
                        <line x1="-1.20036702e-13" y1="12" x2="29.0253555" y2="11.9986061" id="Stroke-10" stroke="#FF8400" strokeWidth="3"></line>
                        <polygon id="Fill-12" fill="#FF8400" points="18.9616519 24 16.9390478 21.8505273 27.6472136 12.001834 16.9390478 2.14947272 18.9616519 0 32 12.001834"></polygon>
                    </g>
                </g>
            </g>
        </svg>
    );
  }

export default IconArrowShortOrange;
